type ContactFootProps = {
  label?: string;
  onContact: () => void;
};

export function ContactFoot({ label = "免费咨询", onContact }: ContactFootProps) {
  return (
    <section className="relative mt-6 overflow-hidden border-t border-[var(--line-soft)] bg-gradient-to-br from-forest-50 to-paper px-[22px] pb-8 pt-8">
      <div
        className="pointer-events-none absolute -right-16 -top-16 h-[220px] w-[220px] rounded-full opacity-60"
        style={{
          background: "radial-gradient(circle, var(--tw-gradient-from), transparent 70%)",
        }}
        aria-hidden
      />
      <p className="kicker relative mb-3 text-coral-700">ASTRA · 留学管家</p>
      <h2 className="relative mb-5 text-[28px] font-bold leading-[1.2] tracking-tight text-ink-900">
        还在犹豫?
        <br />
        <span className="text-coral-700">先聊一聊,不收费。</span>
      </h2>
      <button type="button" onClick={onContact} className="btn-primary relative">
        <span className="flex items-center gap-2">
          {label}
          <ArrowIcon />
        </span>
      </button>
      <p className="relative mt-4 flex items-center gap-2 text-xs text-ink-500">
        <span className="h-1.5 w-1.5 rounded-full bg-forest-500" />
        微信添加顾问 · 工作日 9:00–22:00（新加坡时间）
      </p>
    </section>
  );
}

function ArrowIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden>
      <path
        d="M2.5 7h9M8 3.5L11.5 7 8 10.5"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
